import { makeAutoObservable } from "mobx";
import { notification } from "antd";
import { IBrand, ISimpleResponce } from "@drone-parts.garphild.pro/interfaces";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";

class BrandsStorage {
  brands: IBrand[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  get brandsAsLabels() {
    return this.brands.map((brand) => ({ value: brand._id?.toString() || 'n/a', label: brand.name }));
  }

  addBrand = async (param: {name: string; logoUrl: string, siteUrl: string}) => {
    try {
      const res = await RestApiQuery.post<Partial<IBrand>, ISimpleResponce<IBrand>>(ApiEndpoints.SprBrands, param);
      if (!res) {
        throw new Error("Failed to create brand");
      }

      const status: number = res.status;
      if (status === 200) {
        this.brands = [...this.brands, res.data];
        notification.success({ message: "Brand created" });
      } else {
        notification.error({ message: res.message });
      }
      return res;
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }

  loadBrands = async () => {
    try {
     const response = await RestApiQuery.get<ISimpleResponce<IBrand[]>>(ApiEndpoints.SprBrands);
      if (!response) {
        throw new Error("Failed to load brands");
      }
      this.brands = [...response.data];
      notification.success({ message: "Brands loaded" });
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }
}

const brandsStorage = new BrandsStorage();

export default brandsStorage;
